var _jsxFileName = "/Users/vincent.limshowchen/Sites/account-components/src/components/NoResults/index.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import Icon from "@mlb/react-patterns/dist/components/Icon/icon";
import React from "react";
import { CopyContainer, NoResultsContainer } from "./styles";
var ComponentKey = "no-results";
var NoResults = function NoResults(_ref) {
  var className = _ref.className,
    containerProps = _ref.containerProps,
    _ref$copy = _ref.copy,
    copy = _ref$copy === void 0 ? "We're sorry, we couldn't find any results for" : _ref$copy,
    iconProps = _ref.iconProps,
    query = _ref.query;
  return /*#__PURE__*/React.createElement(NoResultsContainer, _extends({
    className: className,
    "data-testid": ComponentKey
  }, containerProps, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(Icon, _extends({
    name: "sad-baseball",
    width: 56
  }, iconProps, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 7
    }
  })), /*#__PURE__*/React.createElement(CopyContainer, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 7
    }
  }, copy, "\xA0", /*#__PURE__*/React.createElement("b", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 21
    }
  }, "\u201C", query, "\u201D")));
};
export default /*#__PURE__*/React.memo(NoResults);